<template>
  <div class="container my-20">
    <div
      class="mx-auto h-96 w-full max-w-full animate-pulse bg-neutral-200"
    ></div>
  </div>
</template>
